import { useState, useEffect } from 'react';

export default function useDebounceValue<T>(value: T, wait = 500): T {
    const [debounceValue, setDebounceValue] = useState<T>(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebounceValue(value);
        }, wait);

        return () => clearTimeout(timer); // cleanup when unmounted
    }, [value, wait]);

    return debounceValue;
}
